import React, { useEffect, useRef, useState } from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock/mock";
import { TESTIMONIAL_ROTATION_INTERVAL_MS } from "../lib/constants";

const Testimonials = () => {
  const [active, setActive] = useState(0);
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  // Mount-once reveal observer
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && (setShown(true), obs.disconnect()),
      { threshold: 0.2 }
    );
    const node = ref.current;
    if (node) obs.observe(node);
    return () => obs.disconnect();
  }, []);

  // Auto-rotate testimonials
  useEffect(() => {
    const t = setInterval(
      () => setActive((a) => (a + 1) % TESTIMONIALS.length),
      TESTIMONIAL_ROTATION_INTERVAL_MS
    );
    return () => clearInterval(t);
  }, []);

  const current = TESTIMONIALS[active];

  return (
    <section ref={ref} className="bg-black text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <p className="text-[11px] uppercase tracking-[0.32em] text-white/55 mb-10">
          Clients Say
        </p>

        <div className={`reveal ${shown ? "in" : ""}`}>
          <Quote className="w-10 h-10 text-white/40 mb-6" />
          <blockquote className="font-serif-display text-3xl md:text-5xl lg:text-6xl leading-[1.08] max-w-5xl">
            “{current.quote}”
          </blockquote>
          <div className="mt-12 flex items-center justify-between flex-wrap gap-6">
            <div>
              <div className="font-semibold uppercase tracking-[0.18em] text-sm">
                {current.name}
              </div>
              <div className="text-white/55 text-sm mt-1">{current.role}</div>
            </div>
            <div className="flex items-center gap-2">
              {TESTIMONIALS.map((it, i) => (
                <button
                  key={`testimonial-dot-${it.name}-${it.role}`}
                  onClick={() => setActive(i)}
                  aria-label={`Show testimonial ${i + 1}`}
                  className={`h-[2px] transition-all duration-300 ${
                    i === active
                      ? "w-10 bg-white"
                      : "w-6 bg-white/30 hover:bg-white/60"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
